/* eslint-disable jsx-a11y/anchor-has-content */
// TODO: Need to follow up to see if we have some marketing constraints around this,
// given the original code allowed the referer through
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled, { css } from 'styled-components';
import { Heading } from '@99designs/emu';
import { IconRight4 } from '@99designs/icons';
import { COLOR } from './constants';
import { TileProps } from './interfaces';

const Footer = (props: TileProps) => {
    return (
        <StyledFooter text={props.text} author={props.author}>
            <div>
                {props.logo?.url && (
                    // eslint-disable-next-line @next/next/no-img-element
                    <img
                        className={'tile__logo'}
                        src={props.logo.url}
                        title={props.logo.title}
                        alt={props.logo.description}
                    />
                )}
                {(props.designedBy || props.author) && (
                    <Heading
                        className="tile__designedBy"
                        appearanceLevel={6}
                        accessibilityLevel={7}
                        as="p"
                    >
                        {props.author ? (
                            <i>{props.author}</i>
                        ) : props.designedByLink ? (
                            <a href={props.designedByLink} target="_blank">
                                <i style={{ color: props.designedByColor }}>
                                    Designed by {props.designedBy}
                                </i>
                            </a>
                        ) : (
                            <i style={{ color: props.designedByColor }}>
                                Designed by {props.designedBy}
                            </i>
                        )}
                    </Heading>
                )}

                {(props.category || props.business) && (
                    <Heading
                        className="tile__category"
                        appearanceLevel={6}
                        accessibilityLevel={7}
                        as="p"
                    >
                        {props.category || props.business}
                    </Heading>
                )}
            </div>
            {props.link && (
                <a className="tile__link" href={props.link} target="_blank">
                    <IconRight4 />
                </a>
            )}
        </StyledFooter>
    );
};

export default Footer;

export const StyledFooter = styled.div<{ text: string; author: string }>`
    position: relative;
    padding: 10px 10px 20px;
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    color: ${COLOR.WHITE};
    z-index: 2;
    opacity: 0;

    ${(props) =>
        props.text &&
        props.author &&
        css`
            opacity: 1;
        `}

    .tile__logo {
        width: 100px;
        filter: grayscale(1);
    }

    .tile__designedBy {
        padding-left: 20px;
        font-family: Georgia;
        font-weight: 400;
        color: ${COLOR.WHITE};
        a {
            color: inherit;
        }
    }

    .tile__link {
        width: 75px;
        height: 75px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 0;
        right: 0;
        background: ${COLOR.WHITE};
        color: ${COLOR.BLACK};

        &:hover {
            color: ${COLOR.BLACK};
            text-decoration: underline;
        }
    }

    .tile__category {
        padding-left: 20px;
        color: ${COLOR.WHITE};
    }
`;
